import Joi from "joi";
import { emailRegex } from "../../../utils/common";
export const LoginSchema = Joi.object({
    email: Joi.string()
        .pattern(emailRegex)
        .required()
        .messages({
            "string.pattern.base": "Invalid  email format",
            "string.base": "Email is required.",
            "string.required": "Email is required.",
            "string.invalid": "Email is required.",
            "string.empty": "Email is required.",
            "string.email": "Please provide a valid email address.",
        }),
    password: Joi.string()
        .min(6)
        .required()
        .messages({
            "string.empty": "Password is required.",
            "any.invalid": "Password is required.",
            "any.required": "Password is required.",
            "string.base": "Password is required.",
            "string.min":"Password minimum 6 charactors required"

        }),
});